export class DynamicFormRouteModel{
    Id:number;
    Url: string;


    constructor(id:number, url:string){
            this.Id = id;
            this.Url = url;
    }

    public static map(data:any): DynamicFormRouteModel{
       var  model:DynamicFormRouteModel = new DynamicFormRouteModel(data.Id, data.Url);
       return model;
    }
}